import { warningSchema } from "@/schemas/warning-data-schema";
import { IFecthWarningResult } from "@/types/warning-data";

export const fetchWarning = async (): Promise<IFecthWarningResult> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/kuwait_warning/data.json",
		);

		if (!res.ok) {
			throw new Error("Failed to fetch");
		}

		const data = await res.json();

		const validatedData = warningSchema.parse(data);

		return {
			isLoading: false,
			error: null,
			warningData: validatedData.features,
		};
	} catch {
		return {
			isLoading: false,
			warningData: [],
			error: "Une erreur est survenue",
		};
	}
};
